import log from "loglevel";
import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import {
  Breadcrumb,
  Form,
  Button,
  Card,
  Col,
} from "react-bootstrap";
import Navbar from "Screens_old/Layout/Common/Components/NavBar";
// import { FiPlusCircle } from "react-icons/fi";
import JoditEditor from "jodit-react";
// import { FormControl, Select, InputLabel, MenuItem } from "@material-ui/core";
// import Chip from "@mui/material/Chip";
// import Autocomplete from "@mui/material/Autocomplete";
// import TextField from "@mui/material/TextField";
import displayGlobalMessage from "Utils/DisplayGlobalMessage";
import { RiDeleteBinLine } from "react-icons/ri";
import { FaEdit } from "react-icons/fa";
import * as constants from "Constants";
import httpService from "services/httpService";
import HTMLReactParser from "html-react-parser";

const InstructorReply = () => {
  log.log("In Instructor Reply");

  const params = useParams();
  const [issueId, setIssueId] = useState(params.issueId);
  const [lab_Id, setLabID] = useState(params.labId);
  const [courseId, setCourseID] = useState(params.courseId);
  const [issue, setIssue] = useState();
  const [labTitle, setLabTitle] = useState();
  const [statusOption, setStatusOption] = useState();
  const [reply, setReply] = useState();
  const [statuses, setStatuses] = useState();
  const editorRef = useRef(null);
  const [responses, setResponses] = useState([]);
  const [editedResponse, setEditedResponse] = useState(null); // Track currently edited response
  const [isAnnouncement, setIsAnnouncement] = useState(false);
  const [flag, setFlag] = useState(false);
  const [announcements, setAnnouncements] = useState([])
  const userId = useSelector((state) => state.userInfo.userId);
  const isInstructor = useSelector((state) => state.userInfo?.is_instructor);
  log.log("Is Instructor", isInstructor);

  // const { conversion } = require('html-to-text');

  // log.log("Selected Issue : ",selectedIssue);
  useEffect(() => {
    if (lab_Id) {
      if (issueId) {
        var url = constants.base_url + "/issues/getIssue/" + issueId;
        httpService
          .get(url)
          .then((response) => {
            // log.log(response);
            setIssue(response.data?.issue);
            log.log(issue);
            setResponses(response.data?.responses);
            log.log("Responses : ", responses);
            // setStatusOption(response.data?.issue?.status);
            // log.log(selectedIssue);
          })
          .catch((error) => {
            log.log("Error", error);
          });
      }

      var url = constants.base_url + "/issues/getStatusList";
      httpService
        .get(url)
        .then((response) => {
          // log.log(response);
          setStatuses(response.data);
          log.log("Statuses ", statuses);
          // log.log(response.data);
          // log.log(selectedIssue);
        })
        .catch((error) => {
          log.log("Error", error);
        });

      var url = constants.base_url + "/lab/all/" + lab_Id;
      httpService
        .get(url)
        .then((response) => {
          setLabTitle(response.data?.lab?.title);
        })
        .catch((error) => {
          log.log("Error", error);
        });

      var url =
        constants.base_url + "/issues/getIssueAnnouncements/lab/" + lab_Id;
      try {
        httpService.get(url).then((response) => {
          // log.log("Announcements,", response);
          setAnnouncements(response.data);
        });
      } catch (error) {
        log.log("error,", error);
      }
    }
  }, [issueId, flag]);

  const AnnouncementsCard = ({ announcements }) => {
    return (
      <div style={{ marginBottom: "10px" }}>
        <Card style={{ border: "1px solid #ccc", borderRadius: "5px", marginLeft: "5px", marginRight: "5px" }}>
          <Card.Header>
            <h2>Announcements</h2>
          </Card.Header>
          <Card.Body>
            {announcements.map((announcement, index) => (
              <div key={index}>
                <div>
                  <p style={{ fontSize: "18px", marginBottom: "15px" }}>
                    {HTMLReactParser(announcement.message)}
                  </p>
                  <div
                    style={{
                      color: "gray",
                      fontSize: "0.8em",
                      marginTop: "0px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    {/* Display timestamp */}
                    <div>
                      Posted by: {announcement.created_by.username} -{" "}
                      {new Date(announcement.created_on).toLocaleString()}
                    </div>
                    {/* Edit and delete buttons */}
                    <div>
                      {/* <Button variant="info" className="mr-2">
                        <FaEdit />
                      </Button>
                      <Button style={{ backgroundColor: "red" }}>
                        <RiDeleteBinLine />
                      </Button> */}
                    </div>
                  </div>
                  {/* Edit and delete buttons */}
                </div>
                {index !== announcements.length - 1 && (
                  <hr
                    style={{
                      height: "0.3px",
                      border: "none",
                      backgroundColor: "gray",
                      color: "gray",
                    }}
                  />
                )}
              </div>
            ))}
          </Card.Body>
        </Card>
      </div>
    );
  };

  const handleOptionChange = (e) => {
    setStatusOption(e);
    log.log("Status Option", statusOption);
  };

  const handleMarkAsResolved = async () => {
    try {
      const status = "RES";
      const url = constants.base_url + "/issues/updateStatus/" + issueId;
      const response = await httpService.put(url, { status });

      setIssue((prevIssue) => ({
        ...prevIssue,
        status: status,
      }));

      const updatedUrl = constants.base_url + "/issues/getIssue/" + issueId;
      const updatedResponse = await httpService.get(updatedUrl);
      setResponses(updatedResponse.data?.responses);
    } catch (error) {
      log.log("ahhaha");
    }
  };

  const handleMarkAsUnResolved = async () => {
    try {
      const status = "RP";
      const url = constants.base_url + "/issues/updateStatus/" + issueId;
      const response = await httpService.put(url, { status });

      setIssue((prevIssue) => ({
        ...prevIssue,
        status: status,
      }));

      const updatedUrl = constants.base_url + "/issues/getIssue/" + issueId;
      const updatedResponse = await httpService.get(updatedUrl);
      setResponses(updatedResponse.data?.responses);
    } catch (error) {
      log.log("ahhaha");
    }
  };

  const handleClose = () => {
    // Clear the reply input field
    setReply("");

    // Clear Jodit Editor content
    if (editorRef.current) {
      editorRef.current.value = "";
    }
  };

  const findValueByKey = (key) => {
    const choice = statuses.choices.find((choice) => choice.key === key);
    return choice ? choice.value : null;
  };

  const handleEdit = (response) => {
    setEditedResponse(response); // Set the currently edited response
  };

  const handleDelete = async (replyId) => {
    log.log("Deleting reply of issue with reply_id : ", replyId);
    if (confirm("Are you sure You want to delete the Issue ? ")) {
      try {
        var url = constants.base_url + "/issues/deleteResponse/" + replyId;
        const response = await httpService.delete(url);
        setFlag(!flag);

      } catch (error) {
        log.log("Error : ", error);
      }
    }
  };



  if (!issue) {
    return <div>loading</div>;
  }

  const handleSave = async (e, edit) => {
    if (!edit) {
      e.preventDefault();
    }
    log.log("Is Announcement ", isAnnouncement);
    if (isAnnouncement) {
      log.log("In Save Announcement ");
      // log.log("Issue",JSON.stringify(issue));
      const data = {
        message: reply,
        context: "lab",
        context_id: parseInt(lab_Id),
        activity_id: parseInt(issue.activity_id),
        is_instructor: isInstructor,
      };
      log.log("Data : ", data);
      let response;
      try {
        const url = constants.base_url + "/issues/createIssueAnnouncements";
        response = await httpService.post(url, data);
        log.log(response);
      } catch (error) {
        log.log("Error saving response ", error);
      }
    } else {
      log.log("Handlong Save --------------------");
      const data = {
        id: issueId,
        message: reply,
      };

      log.log("isAnnouncement : ", isAnnouncement);

      log.log("data : ", data);

      try {
        let response;
        if (editedResponse) {
          // Update existing response
          log.log("In update Response");
          const url =
            constants.base_url + "/issues/updateResponse/" + editedResponse.id;
          response = await httpService.put(url, data);
        } else {
          // Create new response
          log.log("In handleSave");
          const url = constants.base_url + "/issues/createResponse/";
          response = await httpService.post(url, data);
          log.log(response);
        }

        if (isInstructor) {
          // Update issue status based on user role
          const status = isInstructor ? "RS" : "RP";
          const url = constants.base_url + "/issues/updateStatus/" + issueId;
          await httpService.put(url, { status });
        }
        // Fetch updated responses
        const updatedUrl = constants.base_url + "/issues/getIssue/" + issueId;
        const updatedResponse = await httpService.get(updatedUrl);
        setResponses(updatedResponse.data?.responses);

        setReply("");
        setEditedResponse(null);
        setIsAnnouncement(false);
        displayGlobalMessage("Response saved successfully.", "success");
      } catch (error) {
        log.error("Error saving response:", error);
        displayGlobalMessage(
          "Failed to save response. Please try again.",
          "error"
        );
      }
    }
  };

  const handlePostAnnouncment = () => {
    setIsAnnouncement((prevState) => !prevState);
  };

  const IssueResponses = ({ responses }) => {
    // Sort responses based on timestamp
    const sortedResponses = responses.sort((a, b) => {
      return new Date(a.created_on) - new Date(b.created_on);
    });

    // Function to check if a response is posted by the current user
    const isCurrentUser = (response) => {
      // You need to define the logic to determine if a response is posted by the current user
      // For example, you can compare user IDs or usernames
      // Here, I'm assuming there is a variable called currentUserID which holds the ID of the current user
      return response.created_by.id === userId;
    };

    return (
      <div>
        <Card
          style={{
            marginTop: "10px",
            marginLeft: isCurrentUser(issue) ? "50px" : "0", // Add right margin for cards posted by the current user
            marginRight: isCurrentUser(issue) ? "0" : "50px",
          }}
        >
          <Card.Header>
            <div>{HTMLReactParser(issue.description)}</div>
            <div style={{ color: "gray", fontSize: "0.8em", marginTop: "5px" }}>
              {/* Display timestamp */}
              Posted by - &nbsp;
              {issue.created_by.first_name +
                " " +
                issue.created_by.last_name} -{" "}
              {new Date(issue.created_on).toLocaleString()}
            </div>{" "}
          </Card.Header>
        </Card>
        {sortedResponses.map((response, index) => (
          <Card
            key={index}
            style={{
              marginTop: "10px",
              marginLeft: isCurrentUser(response) ? "50px" : "0",
              marginRight: isCurrentUser(response) ? "0" : "50px",
            }}
          >
            <Card.Header style={{ textAlign: "left", position: "relative" }}>
              {editedResponse && editedResponse.id === response.id ? (
                <>
                  <JoditEditor
                    ref={editorRef}
                    config={
                      {
                        /* Jodit Editor configuration options */
                      }
                    }
                    value={reply || response.message} // Display the previous reply in the editor
                    onBlur={(content) => {
                      setReply(content);
                    }}
                  />
                  <Button onClick={() => handleSave(response, true)}>Submit</Button>
                </>
              ) : (
                <div>{HTMLReactParser(response.message)}</div>
              )}
              <div
                style={{ color: "gray", fontSize: "0.8em", marginTop: "5px" }}
              >
                {/* Display timestamp */}
                {response.last_modified > response.created_on ? (
                  <>Edited by - &nbsp;</>
                ) : (
                  <>Posted by - &nbsp;</>
                )}
                {response.created_by.first_name +
                  " " +
                  response.created_by.last_name}{" "}
                -{" "}
                {new Date(
                  response.last_modified > response.created_on
                    ? response.last_modified
                    : response.created_on
                ).toLocaleString()}
              </div>

              {/* Edit and Delete Buttons */}
              {isCurrentUser(response) && (
                <div
                  style={{ position: "absolute", top: "10px", right: "10px" }}
                >
                  <Button
                    onClick={() => handleEdit(response)}
                    variant="info"
                    className="mr-2"
                  >
                    <FaEdit />
                  </Button>
                  <Button
                    onClick={() => handleDelete(response.id)}
                    style={{ backgroundcolor: "red" }}
                  >
                    <RiDeleteBinLine />
                  </Button>
                </div>
              )}
            </Card.Header>
          </Card>
        ))}
      </div>
    );
  };

  return (
    <div className="cont">
      {isInstructor && <Navbar navbarClass="navbar-dark fixed-top" />}

      <Breadcrumb>
        <Breadcrumb.Item href="#">
          <Link to={`/courseware/course/${courseId}/content/labs`}>Labs</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item href="#">
          <Link to={`/courseware/course/${courseId}/content/labs/${lab_Id}/`}>
            {labTitle}
          </Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item active>Issues</Breadcrumb.Item>
      </Breadcrumb>
      <hr
        style={{
          height: "1px",
          border: "none",
          backgroundColor: "grey",
        }}
      />
      {/* <Navbar navbarClass="navbar-dark fixed-top" />
      <Breadcrumb>
        <Breadcrumb.Item href="#"><Link to={/courseware/course/${courseId}/content/labs}>Labs</Link></Breadcrumb.Item>
        <Breadcrumb.Item href="#"><Link to={/courseware/course/${courseId}/content/labs/${lab_Id}/}>{labTitle}</Link></Breadcrumb.Item>
        <Breadcrumb.Item active>Issues</Breadcrumb.Item>
      </Breadcrumb>
      <div class="d-flex align-items-center row">
        <div class="col-md-4 offset-md-0">
          <h4 style={{ color: "grey", marginLeft: "20px", fontSize: '25px' }}>Issue</h4>
        </div>
      </div>
      <hr style={{ marginLeft: '15px', marginRight: '500px', height: '1px', backgroundColor: 'grey', marginTop: '0px' }}></hr> */}

      {/* <div class="card" style={{ marginRight: '500px', marginLeft: '15px' }}>
        <div class="card-header">
          <div class="row">
          <div class="col-md-11 col-sm-11" style={{fontSize:'25px',marginTop:'10px'}}>
            { selectedIssue.title }
          </div>
          <div class="dropdown" style={{display:'inline-block', marginLeft: '750px', marginTop: '-10px'}}>

                        <div style={{marginRight: '10px', marginBottom: '10px', marginLeft: '300px', marginTop: '-20px'}}>
                            Change Status to:
                            <select>
                                <option value="50">Resolved</option>
                                <option value="100">Unconfirmed</option>
                                <option value="3">Confirmed</option>
                                <option value="3">Reply Sent</option>
                                <option value="3">Reply Pending</option>
                            </select>
                        </div>
                    </div>
          </div>
        </div> */}

      <div>
        <Card
          style={{
            marginLeft: "20px",
            marginRight: "500px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          {/* {(props.formType == "add") && ( */}
          <Card>
            <div style={{ margin: '20px 0' }}>
              <AnnouncementsCard announcements={announcements} />{" "}
              {/* Include the Announcements card component here */}
            </div>
            
          </Card>
          <Card.Header className="d-flex justify-content-between align-items-center">
            <div style={{ display: "flex", alignItems: "center", flex: 1, fontSize: "25px" }}>
              {/* Displaying the issue title at the left end */}
              <div>{issue.title}</div>
              {/* Displaying the status of the crib at the right end */}
              {!isInstructor && (
                <div style={{ marginLeft: "auto", marginRight: "10px" }}>
                  <Button variant="primary" disabled>
                    {findValueByKey(issue.status)}
                  </Button>
                </div>
              )}
            </div>
            {isInstructor && (
              <div>
                <div style={{ display: "inline-block", marginRight: "10px" }}>
                  <Button variant="primary" disabled>
                    {findValueByKey(issue.status)}
                  </Button>
                </div>
                {issue.status != "RES" && (
                  <div style={{ display: "inline-block" }}>
                    <Button variant="success" onClick={handleMarkAsResolved}>
                      Mark as Resolved
                    </Button>
                  </div>
                )}
                {issue.status == "RES" && (
                  <div style={{ display: "inline-block" }}>
                    <Button variant="success" onClick={handleMarkAsUnResolved}>
                      Mark as Unresolved
                    </Button>
                  </div>
                )}
              </div>
            )}
          </Card.Header>

          <Card.Body>
            <IssueResponses responses={responses} />
            <Form onSubmit={handleSave}>
              {/* <Form.Group controlId="description">
                        <Form.Control size = "sm" as = "textarea" rows = {4} name = "content" 
                                      value = {props.editThread ? state.data.content : null} 
                                      placeholder = "Thread Description" onChange = {handleChange}/>
                    </Form.Group> */}

              {/* <div id="editres1" className={'card'} style={{ minHeight: '50px', padding: '10px' }}></div> */}
              <JoditEditor
                ref={editorRef}
                config={
                  {
                    /* Jodit Editor configuration options */
                  }
                }
                value={reply}
                onBlur={(content) => {
                  // Handle content change if needed
                  setReply(content);
                  // log.log("Description");
                  // log.log(Description);
                }}
              ></JoditEditor>
              {isInstructor && (
                <Col md={{ span: 12 }} style={{ paddingLeft: "0px" }}>
                  <label>
                    <input
                      type="checkbox"
                      name="announcement"
                      checked={isAnnouncement}
                      onChange={handlePostAnnouncment}
                    />
                    Post as Announcement
                  </label>
                </Col>
              )}
              <Col md={{ span: 12 }} style={{ paddingLeft: "0px" }}>
                <Button className="btn btn-sm" type="submit">
                  {" "}
                  Post Reply
                </Button>
                <Button
                  className="btn btn-sm mx-2"
                  variant="danger"
                  type="button"
                  onClick={handleClose}
                >
                  {" "}
                  Discard{" "}
                </Button>
              </Col>
            </Form>
          </Card.Body>
        </Card>
      </div>
    </div>
  );
};

export default InstructorReply;
